import {
  Conversation,
  ConversationLogItemMessageAdded,
  ConversationMessage,
} from '@stripe-internal/conversations-client';
import {avatarForMessage} from './avatarForMessage';
import {MessageComponentRegistry} from '../../MessageComponentContext';
import {DefaultMessageComponents} from '../../MessageComponentProvider';

function componentForMessage(
  messageType: ConversationMessage['type'] | 'tool-call',
  components: MessageComponentRegistry = {},
) {
  return components[messageType] ?? DefaultMessageComponents[messageType];
}

export function rowForMessage({
  conversation,
  item,
  avatar,
  animated,
  isLive,
  disableInteraction,
  disableAvatar,
  messageComponentRegistry,
}: {
  conversation: Conversation;
  item: ConversationLogItemMessageAdded;
  avatar?: React.ReactNode | null | undefined;
  animated?: boolean;
  isLive?: boolean;
  disableInteraction?: boolean;
  disableAvatar?: boolean;
  messageComponentRegistry?: MessageComponentRegistry;
}) {
  const itemAvatar = disableAvatar
    ? undefined
    : avatar || avatarForMessage(item);

  const {message} = item;
  const MessageComponent = componentForMessage(
    message.type,
    messageComponentRegistry,
  );

  if (!MessageComponent) {
    return null;
  }

  // TypeScript can't properly narrow union types for dynamic components
  // This is safe because componentForMessage returns the correct component type for the message type
  const Component = MessageComponent as React.ComponentType<any>;
  return (
    <Component
      key={`${message.type}-row-${item.id}`}
      conversation={conversation}
      message={message}
      avatar={itemAvatar}
      animated={animated}
      isLive={isLive}
      disableInteraction={disableInteraction}
    />
  );
}
